import {CustomMarker} from "./CustomMarker";
import {propertyMarkerTemplateIcon} from "../templates/PropertyMarkerTemplate/PropertyMarkerTemplateIcon";
import {propertyMarkerTemplateCard} from "../templates/PropertyMarkerTemplate/PropertyMarkerTemplateCard";
import {priceFilter} from "../../filters/price.filter";

/**
 * Property marker class
 */
export class PropertyMarker extends CustomMarker {
    /**
     * @param latLng {LatLng}
     * @param attributes {PropertyAppResource}
     */
    constructor(latLng, attributes) {
        super(latLng, attributes);
    }

    /**
     * function that returns the template for the property marker icon
     * @returns {string}
     */
    templateIcon() {
        return propertyMarkerTemplateIcon(this);
    }

    /**
     * function that returns the template for the property marker card
     * @returns {string}
     */
    templateCard() {
        return propertyMarkerTemplateCard(this);
    }

    /**
     * overridden method
     * @returns {string}
     */
    getActiveIconClass() {
        return 'property-marker-icon-active';
    }

    get photoSrc() {
        return this.attributes.photoSrc;
    }

    get price() {
        let price = this.attributes.price;
        if (this.attributes.isSold) {
            price = this.attributes.details.salePrice;
        }
        
        return price ? priceFilter(price) : '---';
    }

    get address() {
        return this.attributes.address;
    }

    get isFavorite() {
        return this.attributes.isFavorite ? '<i class="fas fa-heart"></i>' : '';
    }
}
